module.exports = __webpack_public_path__ + "static/media/repeat-1.2a16531b.svg";